
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donationPage",
      function () {
        return require("private-next-pages/donationPage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donationPage"])
      });
    }
  